export const brandIdentity = {
  colors: {
    primary: '#6366F1',
    primaryLight: '#818CF8',
    primaryDark: '#4F46E5',
    secondary: '#10B981',
    accent: '#F59E0B',
    textDark: '#1F2937',
    textLight: '#6B7280',
    backgroundLight: '#F9FAFB',
    white: '#FFFFFF'
  },
  typography: {
    fontFamily: 'Poppins',
    weights: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    },
    sizes: {
      h1: '24px',
      h2: '18px',
      body: '16px',
      small: '14px',
      xs: '12px'
    }
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px'
  }
}; 